import { render, staticRenderFns } from "./ImgView.vue?vue&type=template&id=43b19e26"
import script from "./ImgView.vue?vue&type=script&lang=js"
export * from "./ImgView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInnerLoading,QSpinnerIos,QImg});
